import * as Sentry from '@sentry/vue'
import { router } from '@inertiajs/vue3'

export function configureInertiaSentry(app) {
  if (!isSentryEnabled()) {
    return
  }

  Sentry.init({
    app,
    dsn: __CONCIERGE_SENTRY_PUBLIC_DSN__,
    environment: __APP_ENV__,
    release: __APP_VERSION__,
    integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],

    trackComponents: true,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^\/api\/alfred\//],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1
  })

  nameSpansFromInertiaRoutes()
}

// browserTracingIntegration already creates the pageload span and a
// navigation span for every pushState (Inertia navigates via pushState).
// We only rename those spans to the current Ziggy route name.
function nameSpansFromInertiaRoutes() {
  renameActiveRootSpan('pageload')
  router.on('navigate', () => {
    renameActiveRootSpan('navigation')
  })
}

function renameActiveRootSpan(expectedOp) {
  const activeSpan = Sentry.getActiveSpan()
  const rootSpan = activeSpan && Sentry.getRootSpan(activeSpan)
  if (!rootSpan || Sentry.spanToJSON(rootSpan).attributes['sentry.op'] !== expectedOp) {
    return
  }
  const name = route().current()
  if (name) {
    Sentry.updateSpanName(rootSpan, name)
  }
}

function isSentryEnabled() {
  const dsn = __CONCIERGE_SENTRY_PUBLIC_DSN__
  const isSentryConfigured = dsn && typeof dsn === 'string' && dsn.length > 0
  if (__APP_ENV__ === 'local') {
    return isSentryConfigured && __ANALYTICS_DEBUG__ === true
  }
  return isSentryConfigured
}
